import { useQuery } from '@tanstack/react-query';
import { GetRolesResponseSchema, type GetRolesResponse, type RoleEntity } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export type RolesAdminFilter = 'true' | 'false' | 'all';

export function useRolesAdminList(filter: RolesAdminFilter) {
  const client = useApiClient();
  return useQuery<RoleEntity[]>({
    queryKey: ['roles', 'admin-list', filter],
    queryFn: async ({ signal }) => {
      const res = await client.get<GetRolesResponse>(
        `/roles?archived=${filter}`,
        { signal },
        GetRolesResponseSchema,
      );
      return res.items;
    },
  });
}
